import { render } from "./DownloadSection.vue?vue&type=template&id=264ac21e&scoped=true&ts=true&lang=pug"
import script from "./DownloadSection.vue?vue&type=script&lang=ts"
export * from "./DownloadSection.vue?vue&type=script&lang=ts"

import "./DownloadSection.vue?vue&type=style&index=0&id=264ac21e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ac21e"]])

export default __exports__